import { render, staticRenderFns } from "./ButtonGame.vue?vue&type=template&id=85fa18fc&scoped=true&"
import script from "./ButtonGame.vue?vue&type=script&lang=js&"
export * from "./ButtonGame.vue?vue&type=script&lang=js&"
import style0 from "./ButtonGame.vue?vue&type=style&index=0&id=85fa18fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85fa18fc",
  null
  
)

export default component.exports